<script>
import Vue from 'vue';
import VueLodash from "vue-lodash";
import lodash from "lodash";

Vue.use(VueLodash, {lodash: lodash})

const EventBus = new Vue();

export default {
    props: {
        filterdata: {
            required: false,
            default: ''
        }
    },
    data: function() {
        return {
            modalOpen: false,
            modalId: ''
        }
    },
    methods: {
        toggle() {
            this.modalOpen = !this.modalOpen;
        },
        open() {
            EventBus.$emit('showModal', this);
        },
        handleClose(e) {
            if (e.target.classList.contains('rectangle')) {
                return;
            }
            if (this.closest(e.target, "modal modal-filter-type").length === 0) {
                this.modalOpen = false;
            }
        },
        closest(el, klass) {
            while (el.className !== klass) {
                el = el.parentNode;
                if (!el) {
                    return [];
                }
            }
            return el;
        }
    },
    created() {
        this.modalId = this._.uid;
        //this.modalId = this._.uniqueId('modal_');
    },
    mounted() {
        document.addEventListener("click", this.handleClose.bind(this));

        EventBus.$on('showModal',
            (modalInstance) => {
                if (String(modalInstance.modalId) === String(this.modalId)) {
                    this.toggle();
                } else {
                    this.modalOpen = false;
                }
            });
    }
}
</script>